export default "__VITE_ASSET__Zz7o_7NeIMnYzYvY1rh_AA__ 480w, __VITE_ASSET__pOuA6Cgw0Hs2VRp4syQvcg__ 745w";